<template>
  <div class="_content">
    <div class="recruit-canvas">
      <div class="text-box">
        <div class="back" @click="goBack">返回</div>
        <span class="middle">请签名</span>
      </div>
      <div class="canvas-out-box">
        <div class="canvas-box" ref="canvasRef" >
          <canvas ref="canvasMapRef" id="canvas-map" width="100" height="100" />
        </div>
      </div>
      <div class="btn-box flex-row">
        <div class="btn-text"> 
          <van-icon name="info" color="#1989fa" />
          <span class="text">本人确认已完成检测</span>
        </div>

        <div class="btn-boxs">
          <van-button size="small" @click="clearHandle" class="no-use">一键清除</van-button>
          <van-button size="small" @click="confirmHandle" type="info">确认签名</van-button>
        </div>
      </div>
       <slot name="default" :signatrue="canvasNode"></slot>
    </div>

  </div>
</template>
<script>
import config from '@/configs/config'
import SignaturePad from "signature_pad";
import { rotateBase64Img } from "./sign"; //这是使用的方法，当手机屏幕是竖屏的时候要旋转图片

export default {
  data() {
    return {
      canvasNode: "",
      signPic: "",
      flag: true,
    };
  },
  created() {
    this.$nextTick(() => {
      this.initalHandle();
      window.addEventListener("resize", this.initalHandle, false);
    });
  },
  methods: {
    goBack() {
      tuhu.navigateBack()
    },
    initalHandle() {
      const _canvasBox = this.$refs.canvasRef;
      const _canvas = this.$refs.canvasMapRef;
      if (!_canvasBox || !_canvas) {
        console.warn("DOM节点初始化失败");
        return false;
      }

      _canvas.width = _canvasBox.clientWidth;
      _canvas.height = _canvasBox.clientHeight;
      const computedOpt = Object.assign(
        {},
        {
          minWidth: 1, //因为有笔锋的效果的，鼠标压力不同显示粗细不同
          maxWidth: 1,
          penColor: "rgb(0, 0, 0)",
        }
      );

      this.clearHandle();
      this.canvasNode = new SignaturePad(_canvas, computedOpt); //这里设置笔的宽度和颜色的样式
    },

    clearHandle() {
      const hasNode = this.canvasNode;
      if (hasNode) {
        hasNode.clear();
      }
    },

    async confirmHandle() {
      // 重新初始化画布
      const canvasNode = this.canvasNode;
      if (!canvasNode) {
        this.initalHandle();
      }
      // 是否签字
      if (canvasNode.isEmpty()) {
        tuhu.toast("您还没有签名");
        return false;
      }
      // 图像旋转二次处理
      const _boxWidth = window.innerWidth;
      const _boxHeight = window.innerHeight;
      const _signImg = canvasNode.toDataURL("image/png", 0.6) || null; //不旋转就是手机横屏
      if (_boxWidth < _boxHeight) {
        await rotateBase64Img(_signImg, -90, (imgUrlRes) => {
          //在这里修改逻辑，返回的是旋转后的database
          this.imgBase64ToUrl(imgUrlRes);
        });
      }else{
          this.imgBase64ToUrl(_signImg);
      }
    },
    async imgBase64ToUrl(data) {
      if (!this.flag) return;
      this.flag = false;
      let params = {
        baseFile: data,
        fileName: "签名.png",
      };
      tuhu.fetch(`${config.apis.UploadBase64File}`, {
          method: 'post',
          headers: {
              'Content-Type': 'application/json'
            },
          body:JSON.stringify(params)
        }).then((res) => {
           console.log('点击确认',res)
          if (res.code === '200') {
            this.signPic = res.data;
            this.combineText()
          } else {
            this.flag = true;
            tuhu.toast(res.message);
          }
        })
        .catch((err) => {
          this.flag = true;
          console.log('点击确认',err)
        });
    },
    // 需要正文
    async combineText() {
      await tuhu.fetch(`${config.apis.GetSignature}?signature=${this.signPic}`).then((res) => {
          this.flag = true;
          if (res.code === '200') {
            //向跳转的上一页传参
            window.parent.postMessage(res.data)
            console.log(res,'re3s',res.data)
            tuhu.navigateBack();
          } else {
            tuhu.toast(res.message);
          }
        })
        .catch((err) => {
          this.flag = true;
          tuhu.toast(err.message);
        });
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.initalHandle, false);
  },
};
</script>
<style scoped lang="less">
@media screen and (orientation: portrait) {

  /*竖屏 css*/
  .recruit-canvas {
    position: fixed;
    background-color: white;
    display: flex;
    flex-direction: column;
    width: 100vh;
    height: 100vw;
    padding: 15px;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(90deg);

    .canvas-out-box {
      height: 74vw;
      width: calc(100vh - 30px);
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      .canvas-box {
        width: 70vw;
        height: 90vh;
        transform:  rotate(270deg);
        overflow: hidden;
        background-color: #fff;
        border: 1px dashed #d4d4d4;
        

        #canvas-map {
          width: 100%;
          height: 100%;
        }
      }
    }

    .text-box {
      padding-left: 30px;
      z-index: 1000;
      width: 100vh;
      height: 30px !important;
      line-height: 30px;
      white-space: nowrap;
      writing-mode: horizontal-tb;
      display: flex;
      flex-direction: row;

      .back {
        color: #0079fe;
        font-size: 14px;
      }
      .middle {
        margin-left:calc( 50vh - 52px);
      }
    }

    .btn-box {
      padding-left: 30px;
      z-index: 1000;
      width: 100%;
      margin-top: 5px;
      height: 30px !important;
      display: flex;
      flex-direction: row;
      align-items: center;
      white-space: nowrap;
      writing-mode: horizontal-tb;
      .btn-text {
        flex:1;
      }
      .btn-boxs {
        flex:1;
        .no-use {
          color: #0079fe;
          background-color: #0079fe19;
          border-color: #0079fe;
          border-width: 2px;
        }

        .van-button {
          width: 80px;
          height: 30px;
          font-size: 13px;

          &:nth-of-type(1) {
            border-width: 1px;
          }
        }
      }

      .van-button:nth-of-type(1) {
        // font-size: 30px;
        margin-right: 20px;
      }
    }
  }

}

@media screen and (orientation: landscape) {

  /*横屏 css*/

  .recruit-canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;

    .canvas-box {
      z-index: 100;
      position: absolute;
      z-index: 100;
      top: 13%;
      left: 5%;
      width: 90%;
      height: 70%;
      transform: translateY(0);
      overflow: hidden;
      background-color: #fff;
      border: 1px dashed #d4d4d4;
       #canvas-map {
        width: 100%;
        height: 100%;
      }
    }

    .btn-box,
    .text-box {
      position: absolute;
      z-index: 1000;
      text-align: center;
    }
    
    .btn-box {
      width: 70%;
      top: 86%;
      left: 10%;
      transform: rotate(0);

      .text {
        white-space: nowrap;
        font-size: 12px;
        margin: 0 10px;
      }

      .van-button {
        width: 80px;
        height: 30px;
        font-size: 13px;

        &:nth-of-type(1) {
          border-width: 1px;
        }
      }
    }

    .text-box {
      width: 100%;
      top: 1%;
      transform: rotate(0);
      text-align: center;
      .back {
        color: #0079fe;
        position: absolute;
        font-size: 14px !important;
        left: 50px;
        top: 0;
      }
    }
    .flex-row {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .text {
        white-space: nowrap;
        font-size: 13px;
        margin: 0 10px;
      }

      .no-use {
        color: #0079fe;
        background-color: #0079fe19;
        border-color: #0079fe;
        border-width: 2px;
      }

      .van-button {
        width: 80px;
        height: 30px;
        font-size: 13px;

        &:nth-of-type(1) {
          border-width: 1px;
        }
      }

      .van-button:nth-of-type(1) {
        // font-size: 30px;
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/verifyCode/onlineSign.vue